export default {
  name: "auth",
  component: () =>
    import(
      /* webpackChunkName: "authLayout" */ "@/modules/auth/layouts/authLayout.vue"
    ),
  redirect: "/auth/login",
  children: [
    {
      path: "login",
      name: "auth-login",
      component: () =>
        import(
          /* webpackChunkName: "login" */ "@/modules/auth/pages/Login.vue"
        ),
    },
    {
      path: "forgotPassword",
      name: "auth-forgotPassword",
      component: () =>
        import(
          /* webpackChunkName: "forgotPassword" */ "@/modules/auth/pages/ForgotPassword.vue"
        ),
    },
    {
      path: "restartPassword",
      name: "auth-restartPassword",
      component: () =>
        import(
          /* webpackChunkName: "forgotPassword" */ "@/modules/auth/pages/RestartPassword.vue"
        ),
        props: (route) => ({
          token: route.query.token,
          username: route.query.username
        })
    },
  ],
};
